import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import ProposalOverview from './ProposalOverview';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ProposalPage = () => {
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API}/value-proposition`);
      setOverview(res.data?.proposalOverview || null);
    } catch (err) {
      console.error('Failed to load proposal overview:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  if (loading || !overview) {
    return (
      <div className="flex items-center justify-center h-96" data-testid="proposal-page-loading">
        <div className="w-8 h-8 border-3 border-[#E5E5E5] border-t-[#171717] rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div data-testid="proposal-page">
      <ProposalOverview overview={overview} />
    </div>
  );
};

export default ProposalPage;
